import { IconButton, SwipeableDrawer, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotifications,
  markAllNotificationsAsRead,
  toggleNotifcationPanel,
} from "../../../../redux/actions/notificationsActions";
import { selectIsPanelOpen, selectNotifications } from "../../../../redux/selectors/notifications";
import {
  LinkButton,
  NotificationsHeader,
  NotificationsWrapper,
  StyledAppBar,
  StyledTab,
} from "./notifications-drawer.styles";
import { NotificationListItem } from "../notification-list-item/notification-list-item.component";
import { Heading } from "../../../../components/headers/heading/heading.component";
import { TabsPanel } from "../../../../components/layout/tabs/components/tabs-panel/tabs-panel.component";

const useStyles = makeStyles(() => ({
  tab: {
    "&:hover": {
      color: "#00CAFF",
      "font-weight": "bold",
    },
  },
}));

export const NotificationsDrawer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [currentTabValue, setCurrentTabValue] = useState(0);
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setCurrentTabValue(newValue);
  };
  const notificationsResults = useSelector(selectNotifications);
  const isOpen = useSelector(selectIsPanelOpen);

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  const handleMarkAll = () => {
    dispatch(markAllNotificationsAsRead());
  };

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }
    dispatch(toggleNotifcationPanel());
  };

  const unreadData = notificationsResults.filter((item) => item.unread === true);
  const readData = notificationsResults.filter((item) => item.unread === false);

  return (
    <SwipeableDrawer
      anchor="right"
      open={isOpen}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
    >
      <NotificationsWrapper>
        <NotificationsHeader>
          <Heading variant="secondary">Notifications</Heading>
          <IconButton onClick={toggleDrawer(false)} aria-label="close">
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </NotificationsHeader>
        <StyledAppBar>
          <Tabs
            indicatorColor="primary"
            value={currentTabValue}
            onChange={handleTabChange}
            aria-label="Notifcation tabs"
          >
            <StyledTab
              className={classes.tab}
              label="Unread"
              onClick={() => {
                setCurrentTabValue(0);
              }}
              selected={currentTabValue === 0}
            />
            <StyledTab
              className={classes.tab}
              label="Read"
              onClick={() => {
                setCurrentTabValue(1);
              }}
              selected={currentTabValue === 1}
            />
          </Tabs>
          {currentTabValue === 0 && (
            <LinkButton disabled={unreadData.length === 0} onClick={handleMarkAll}>
              Mark all as read
            </LinkButton>
          )}
        </StyledAppBar>
        <TabsPanel value={currentTabValue} index={0}>
          <NotificationListItem items={unreadData} onClose={toggleDrawer(false)} />
        </TabsPanel>
        <TabsPanel value={currentTabValue} index={1}>
          <NotificationListItem items={readData} onClose={toggleDrawer(false)} />
        </TabsPanel>
      </NotificationsWrapper>
    </SwipeableDrawer>
  );
};
